import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../wayfinder'
/**
* @see \App\Http\Controllers\AuthController::updateName
* @see app/Http/Controllers/AuthController.php:184
* @route 'https://app.pokor.dev/user/name'
*/
export const updateName = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updateName.url(options),
    method: 'put',
})

updateName.definition = {
    methods: ["put"],
    url: 'https://app.pokor.dev/user/name',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\AuthController::updateName
* @see app/Http/Controllers/AuthController.php:184
* @route 'https://app.pokor.dev/user/name'
*/
updateName.url = (options?: RouteQueryOptions) => {
    return updateName.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::updateName
* @see app/Http/Controllers/AuthController.php:184
* @route 'https://app.pokor.dev/user/name'
*/
updateName.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updateName.url(options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\AuthController::updateTimezone
* @see app/Http/Controllers/AuthController.php:205
* @route 'https://app.pokor.dev/user/timezone'
*/
export const updateTimezone = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updateTimezone.url(options),
    method: 'put',
})

updateTimezone.definition = {
    methods: ["put"],
    url: 'https://app.pokor.dev/user/timezone',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\AuthController::updateTimezone
* @see app/Http/Controllers/AuthController.php:205
* @route 'https://app.pokor.dev/user/timezone'
*/
updateTimezone.url = (options?: RouteQueryOptions) => {
    return updateTimezone.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::updateTimezone
* @see app/Http/Controllers/AuthController.php:205
* @route 'https://app.pokor.dev/user/timezone'
*/
updateTimezone.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updateTimezone.url(options),
    method: 'put',
})

const user = {
    updateName: Object.assign(updateName, updateName),
    updateTimezone: Object.assign(updateTimezone, updateTimezone),
}

export default user